var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.languages),function(lang){return _c('span',{key:lang[0]},[_c('router-link',{attrs:{"to":'/languages/' + lang[0],"lang":lang[0]}},[_vm._v(_vm._s(lang[1]))]),_vm._v(", ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }